import React, { FC } from 'react';
import { Box } from '@mui/material';
import styles from './contact-us.module.css';

interface ContactItem {

  icon: React.ReactNode;

  label: string;

  value: string;
}

export interface ContactUsProps {

  items: ContactItem[];

}

export const ContactUs: FC<ContactUsProps> = ({ items }) => {
  return (
    <Box className={styles.contactUsContainer}>
      <div className={styles.contactUsContent} >
        <div className={styles.contactUsTitleContainer}>
          <div className={styles.headerBar}></div>
          <div className={styles.contactUsTitle}>Fale Conosco</div>
        </div>

        <div className={styles.contactUsGrid}>
          {items.map((item, index) => (
            <div key={index} className={styles.contactUsItem}>
              <div className={styles.contactUsIcon}>{item.icon}</div>
              <div>
                <div className={styles.contactUsLabel}>{item.label}</div>
                <div className={styles.contactUsValue}>{item.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Box>
  );
};